import * as Yup from "yup";

export const featureTemplateValidators = Yup.object().shape({
  name: Yup.string().nullable(true).required("Feature template must has a name"),
});
